import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";
import { apiClient } from "../../utils/api";

interface KakaoSignupData {
  code: string;
  redirect_url: string;
  private_agreement: boolean;
  service_agreeement: boolean;
  marketing_agreement: boolean;
}

interface UseKakaoSignupReturn {
  isLoading: boolean;
  error: string;
  signupWithKakao: (data: KakaoSignupData) => Promise<void>;
  clearError: () => void;
}

const useKakaoSignup = (): UseKakaoSignupReturn => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  
  const signIn = useAuthStore((state) => state.signIn);

  const signupWithKakao = async (data: KakaoSignupData) => {
    setIsLoading(true);
    setError("");

    try {
      const response = await apiClient.post("/api/v1/auth/kakao_signup_20250904", {
        data,
      });

      const result = response.data;

      if (!result.status) {
        throw new Error(result.error || "카카오 회원가입에 실패했습니다.");
      }

      // 회원가입 성공 - 토큰 저장 및 대시보드로 이동
      signIn(
        {
          accessToken: result.access_token,
          refreshToken: result.refresh_token,
        },
        result.data
      );
      
      navigate("/");
    } catch (err: any) {
      console.error("카카오 회원가입 오류:", err);
      setError(err.message || "카카오 회원가입 중 오류가 발생했습니다.");
    } finally {
      setIsLoading(false);
    }
  };

  const clearError = () => {
    setError("");
  };

  return {
    isLoading,
    error,
    signupWithKakao,
    clearError,
  };
};

export default useKakaoSignup;
